import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { SalesChartComponent } from "../charts";
import { Carousel, Modal, Button, Form, Alert } from "react-bootstrap";
import Image1 from "../../assets/images/img-1.jpg";
import Image2 from "../../assets/images/img-2.jpg";
import Image3 from "../../assets/images/img-3.jpg";
import "../../../src/assets/sass/custom.css";
export default function DashBoardImageSlider() {
  const { t } = useContext(TranslatorContext);
  return (
    <div className="mc-sales-card" style={{ height: "300px" }}>
      <Carousel fade>
        <Carousel.Item>
          <img
            style={{ borderRadius: "10px", objectFit: "cover" }}
            src={Image1}
            width="100%"
            height="300px"
          ></img>
        </Carousel.Item>

        <Carousel.Item>
          <img
            style={{ borderRadius: "10px", objectFit: "cover" }}
            src={Image2}
            width="100%"
            height="300px"
          ></img>
        </Carousel.Item>

        <Carousel.Item>
          <img
            style={{ borderRadius: "10px", objectFit: "cover" }}
            src={Image3}
            width="100%"
            height="300px"
          ></img>
        </Carousel.Item>
      </Carousel>

      
    </div>
  );
}
